


export const emailValidator = (email) => {
    if (!email) {
      return {touched:false,error:false,message:""};
    } 
    else if (!new RegExp(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,}$/).test(email)) {
      return {touched:true,error:true,message:"Incorrect email format"};
    }

    return {touched:true,error:false,message:"Success!"};
  };

  export const nameValidator = (name) => {
    if (!name) {
      return {touched:false,error:false,message:""};
    } 
    else if (!new RegExp(/^[a-zA-Z가-힣\s]{1,20}$/).test(name)) {
      return {touched:true,error:true,message:"can't allowed special letter"};
    }

    return {touched:true,error:false,message:"Success!"};
  };


  export const detailValidator = (detail) => {
    if (!detail) {
      return {touched:false,error:false,message:""};
    } 
    return {touched:true,error:false,message:"Success!"};
  };

  export const regionValidator = (region) => {
    if (!region) {
      return {touched:false,error:false,message:""};
    } 
    else if (!new RegExp(/^[a-zA-Z가-힣\s]{1,20}$/).test(region)) {
      return {touched:true,error:true,message:"can't allowed special letter"};
    }

    return {touched:true,error:false,message:"Success!"};
  };